<li class="list-inline-item gt-icon gt-icon-google border-solid border border-default bg-white" (click)="googleSigin()"></li>
